module.exports = __webpack_public_path__ + "img/money-bag.f1d20f7.svg";